export default () => ({
  contactPageFormUrl: null,
  unitContactFormData: {
    buttonText: null,
    formUrl: null,
  },
})
